import { useEffect, useState } from "react";
import { Toaster as Sonner } from "sonner";

/**
 * Custom toaster wrapper:
 * - desktop (>= 640px): bottom-right
 * - mobile (< 640px):   bottom-center
 * - visible gutter so toast never covers navigation or content
 */
export function AppToaster() {
  const [position, setPosition] = useState(
    typeof window !== "undefined" && window.innerWidth < 640
      ? "bottom-center"
      : "bottom-right"
  );

  useEffect(() => {
    const handler = () => {
      setPosition(window.innerWidth < 640 ? "bottom-center" : "bottom-right");
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <Sonner
      position={position}
      richColors
      closeButton
      visibleToasts={3}
      gap={8}
      offset={24}
      toastOptions={{
        duration: 3000,
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
        },
      }}
    />
  );
}
